var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconKnowledgePlugin = function SvgIconKnowledgePlugin(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9CC5FF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.13,0.01L9.41,0l0,0H6.6l0,0H3.87C2.84,0,1.99,0.85,1.99,1.88L1.99,14.12c0,1.04,0.84,1.88,1.88,1.88h8.26 c1.04,0,1.88-0.84,1.88-1.88l0.01-12.23C14.01,0.85,13.17,0.01,12.13,0.01z M13.26,14.12c0,0.62-0.51,1.13-1.13,1.13H3.87 c-0.62,0-1.13-0.51-1.13-1.13L2.74,1.88c0-0.62,0.51-1.13,1.13-1.13h8.26c0.62,0,1.13,0.51,1.13,1.13L13.26,14.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.92,6.06H5.43c-0.21,0-0.38,0.17-0.38,0.38s0.17,0.38,0.38,0.38h5.49c0.21,0,0.38-0.17,0.38-0.38 S11.12,6.06,10.92,6.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.92,2.94H5.43c-0.21,0-0.38,0.17-0.38,0.38s0.17,0.38,0.38,0.38h5.49c0.21,0,0.38-0.17,0.38-0.38 S11.12,2.94,10.92,2.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.92,9.19H5.43c-0.21,0-0.38,0.17-0.38,0.38s0.17,0.38,0.38,0.38h5.49c0.21,0,0.38-0.17,0.38-0.38 S11.12,9.19,10.92,9.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.92,12.31H5.43c-0.21,0-0.38,0.17-0.38,0.38s0.17,0.38,0.38,0.38h5.49c0.21,0,0.38-0.17,0.38-0.38 S11.12,12.31,10.92,12.31z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconKnowledgePlugin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_knowledge_plugin.9970b53754af7ff263e66e0f32a1ec37.svg";